import { updateGroupMembers as updateGroupMembersAction, useUpdateGroupMembers } from './updateGroupMembers'

// Plain action creator for backward compatibility
export function updateAlertSetGroupMembers (members) {
  return updateGroupMembersAction('alertSetGroupMembers', members)
}

// Hook for backward compatibility
export function useUpdateAlertSetGroupMembers () {
  const { updateGroupMembers, userChecked, info } = useUpdateGroupMembers('alertSetGroupMembers')
  return {
    updateAlertSetGroupMembers: updateGroupMembers,
    userChecked,
    info
  }
}
